<template>
	<div>
		<!-- Preview mode -->
		<j-card class="xs-12 bg5">
			<div class="p2">
				<div class="xs-12 p2" v-for="(item, i) in schema" :key="i">
					<div v-if="item.type === 'HEADLINE'" class="fw7 fs6 lh150 pb2 pt2">
						{{ item.localizedContent }}
					</div>
					<div v-if="item.type === 'TEXT'" class="fs4 lh125">
						{{ item.localizedContent }}
					</div>
					<div v-if="item.type === 'LIST'" class="pl8">
						<div v-for="(listItem, i) in item.options" :key="i" class="lh125">
							- {{ listItem.localizedContent }}
						</div>
					</div>
					<div v-if="item.type === 'QUIZZ'" class="pl8">
						<div class="fs4 lh125">{{ item.localizedContent }}</div>
						<div v-for="(quizzItem, i) in item.options" :key="i" class="lh125">
							<div class="flex xs-12 pt2 xs-middle">
								<j-checkbox size="small" />
								<div class="pl4">{{ quizzItem.localizedContent }}</div>
							</div>
						</div>
					</div>
					<div v-if="item.type === 'HTML'" v-html="item.localizedContent"></div>
					<div
						v-if="item.type === 'IMAGE' && item.localizedContent"
						class="xs-12"
					>
						<lesson-preview-image :filekey="item.localizedContent" />
					</div>

					<div v-if="item.type === 'VIDEO' && item.localizedContent">
						<lesson-preview-video :filekey="item.localizedContent" />
					</div>
				</div>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCheckbox from "@/components/JCheckbox"
import JCard from "@/components/JCard"
import LessonPreviewImage from "./LessonPreviewImage"
import LessonPreviewVideo from "./LessonPreviewVideo"

export default {
	name: "LessonPreview",
	props: {
		lesson: Object,
		courseId: String
	},
	computed: {
		schema() {
			return this.lesson?.items || []
		}
	},
	components: {
		JCard,
		JCheckbox,
		LessonPreviewImage,
		LessonPreviewVideo
	}
}
</script>
